module.exports = __webpack_public_path__ + "media/theme/arrow-10-cc1396f7.png";